import { z } from "zod";

export const validateAddCardTokenRequestSchema = z.object({
  token: z.string().min(1),
});

export const validateAddCardTokenResponseSchema = z.object({
  token: z.object({
    companyID: z.string(),
    workerID: z.string(),
    company_name: z.string(),
    company_logo_url: z.string().optional(),
    worker_type: z.string(),
    worker_email: z.string(),
    worker_name: z.string(),
    test_mode: z.boolean(),
  }),
  astra_worker: z
    .object({
      id: z.string(),
      token: z.string(),
      env: z.enum(["sandbox", "live"]),
      tenant: z.string(),
      url: z.string(),
      access_token: z.string(),
    })
    .nullable(),
});

export type TValidateAddCardTokenRequestSchema = z.infer<
  typeof validateAddCardTokenRequestSchema
>;

export type TValidateAddCardTokenResponseSchema = z.infer<
  typeof validateAddCardTokenResponseSchema
>;
